<script lang="ts" setup>
import type { FieldData, CheckboxOption } from '~~/server/api/forms/form'
import './FormKitCustomOptions.scss'

export interface FormKitCustomOptionsProps {
    data: FieldData;
}
export type OptionsObject = Record<string, string>;

const props = defineProps<FormKitCustomOptionsProps>()
const route = useRoute()
const model = ref<string[]>([])

if (route.query.insurance) {
    model.value.push(String(route.query.insurance))
}

const options = computed<OptionsObject>((): OptionsObject => {
    if (!props.data.list_options?.length) return {}
    const data: OptionsObject = {}

    props.data.list_options.forEach((option: CheckboxOption): void => {
        data[option.value.toString()] = option.label
    })

    return data
})
</script>
<template>
  <!-- Accessibility: FormKit checkbox group with options auto-generates fieldset with legend (WCAG 1.3.1) -->
  <div class="form-kit-custo-options-wrapper">
    <p
      v-if="props.data.help"
      :id="`help-${props.data.name}`"
      class="formkit-help"
    >
      {{ props.data.help }}
    </p>
    <FormKit
      v-model="model"
      :options="options"
      :label="props.data.label"
      type="checkbox"
      :validation="props.data.validations"
      :validation-messages="{
        required:
          props.data.validation_messages?.['required'] ||
          $t('Vyberte aspoň jedno poistenie.'),
      }"
      :name="props.data.name"
      :help-attrs="props.data.help ? { id: `help-${props.data.name}` } : undefined"
      :delay="600"
    />
  </div>
</template>
